$(document).ready ->
  $('.faq-category-sortable').sortable({
    cursor: 'move'
  })
  
  current_value = 0 
  current_text = ""
  next_text = ""
  current_name = ""
  next_name = ""

  $(".order_faq_number").focus (event) ->
    current_value = $(event.target).val()
    current_text = $(event.target).parent().siblings().first().html().trim()
    next_text = $(event.target).parent().siblings().first().html().trim()    
    current_name = $(event.target).attr("name")
    next_name = $(event.target).attr("name")    
    return

  $(".order_faq_number").change (event) ->
    check = false
    if parseInt($(event.target).val(),10) <= parseInt(current_value,10)
      check = true
    if check == true
      for key in $(".order_faq_number")
        if $(key).html() != $(event.target).html()
          if (parseInt($(key).val(),10) < parseInt(current_value, 10) && parseInt($(key).val(),10) >= parseInt($(event.target).val(),10)) 
            current_text = next_text
            current_name = next_name

            next_text = $(key).parent().siblings().first().html().trim()
            next_name = $(key).attr("name")

            $(key).parent().siblings().first().html(current_text)
            $(key).attr("name",current_name)
        else
          $(key).parent().siblings().first().html(next_text)
          $(key).attr("name",next_name)        
          $(key).val(current_value)
    else
      count = 0
      prev = ""
      for key in $(".order_faq_number")
        if count == 1
          $(prev).parent().siblings().first().html($(key).parent().siblings().first().html())
          $(prev).attr("name",$(key).attr("name"))        
          
        if ( parseInt($(key).val(),10) == parseInt($(event.target).val(),10) )
          if count == 0
            current_text = $(event.target).parent().siblings().first().html().trim()
            current_name = $(event.target).attr("name")
          count++
          
        if count == 2          
          next_text = $(key).parent().siblings().first().html()
          next_name = $(key).attr("name")
          $(key).parent().siblings().first().html(current_text)
          $(key).attr("name",current_name)
          current_text = next_text
          current_name = next_name          
          break
        prev = $(key)        
      $(event.target).val(current_value)
    return
  return